import React from 'react';
import { IndexRoute, Router, Route } from 'react-router';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { store, history } from 'core/store';

import * as reservas from 'modules/reservas/component';
import * as abonados from 'modules/abonados/component';
import * as rutinas from 'modules/rutinas/component';
import * as viajes from 'modules/viajes/component';
import * as vehiculos from 'modules/vehiculos/component';
import * as dispositivos from 'modules/dispositivos/component';
import * as asignacion from 'modules/asignacion/component';
import * as general from 'modules/general/component';
import * as feriados from 'modules/feriados/component';
import * as mapa from 'modules/mapaGeneral/component';
import * as paradas from 'modules/paradas/component';
import * as registros from 'modules/registros/component';
import * as roles from 'modules/roles/component';
import * as mensajes from 'modules/mensajes/component';
import * as trayectos from 'modules/trayectos/component';
import * as reportes from 'modules/reportes/component';
import * as grupos from 'modules/grupos/component';
import * as gruposSolicitudes from 'modules/gruposSolicitudes/component';
import * as precios from 'modules/precios/component';
import * as penalizaciones from 'modules/penalizaciones/component';

import theme from './styles/theme';

import * as usersActions from 'modules/user/action';

export default class extends React.Component {
  checkLogin = () => {
    !store.getState().getIn(['user', 'access_token']) && store.dispatch(usersActions.checkLogin());
  };
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider muiTheme={getMuiTheme(theme)}>
          <div>
            <general.LoadingbarC />
            <Router history={history}>
              <Route path="/" component={general.LoadingScreenC} onEnter={this.checkLogin} />
              <Route path="/notificacion" component={general.NotificacionC} />
              <Route path="/dashboard" component={general.DashboardC} onEnter={this.checkLogin}>
                <Route path="mapa">
                  <IndexRoute component={mapa.MapaC} />
                </Route>
                <Route path="roles">
                  <IndexRoute component={roles.MainC} />
                  <Route path="add/:id/:nombre/:apellido" component={roles.AddC} />
                </Route>
                <Route path="reservas">
                  <Route path="add/:reservaId/:viajeId" component={reservas.AddC} />
                  <Route path="main" component={viajes.MainC} />
                  <Route path="pasajeros/:viajeId" component={viajes.PasajerosC} />
                  <Route path="reservasPendientes/:probable" component={reservas.ReservasPendientesC} />
                </Route>
                <Route path="abonados">
                  <IndexRoute component={abonados.MainC} />
                  <Route path="add/:abonadoId/:isUser" component={abonados.AddC} />
                  <Route path="abono/:abonadoId" component={abonados.AbonosC} />
                  <Route path="activos" component={abonados.AbonadosActivosC} />
                </Route>
                <Route path="vehiculos">
                  <IndexRoute component={vehiculos.MainC} />
                  <Route path="add/:vehiculoId" component={vehiculos.AddC} />
                </Route>
                <Route path="dispositivos">
                  <IndexRoute component={dispositivos.MainC} />
                  <Route path="tasks/:dispositivoId" component={dispositivos.TasksC} />
                </Route>
                <Route path="viajes">
                  <IndexRoute component={asignacion.MainC} />
                  <Route path="add/:viajeId" component={viajes.AddC} />
                  <Route path="trayecto/:viajeId" component={viajes.TrayectoViajeC} />
                </Route>
                <Route path="rutinas">
                  <IndexRoute component={rutinas.MainC} />
                  <Route path="add/:rutinaId" component={rutinas.AddC} />
                </Route>
                <Route path="feriados" component={feriados.MainC} />
                <Route path="paradas">
                  <IndexRoute component={paradas.MainC} />
                  <Route path="add/:paradaId" component={paradas.AddC} />
                </Route>
                <Route path="mensajes">
                  <IndexRoute component={mensajes.ListadoC} />
                  <Route path="add/:mensajeId" component={mensajes.AddC} />
                </Route>
                <Route path="trayectos">
                  <IndexRoute component={trayectos.MainC} />
                  <Route path="add/:trayectoId" component={trayectos.AddC} />
                </Route>
                <Route path="grupos">
                  <IndexRoute component={grupos.MainC} />
                  <Route path="add/:grupoId" component={grupos.AddC} />
                </Route>
                <Route path="precios">
                  <IndexRoute component={precios.MainC} />
                  <Route path="add" component={precios.AddC} />
                  <Route path="add/:nombrePrecio" component={precios.AddC} />
                </Route>
                <Route path="penalizaciones">
                  <IndexRoute component={penalizaciones.MainC} />
                </Route>
                <Route path="gruposSolicitudes" component={gruposSolicitudes.ListaView} />
                <Route path="registros" component={registros.MainC} />
                <Route path="reportes" component={reportes.ListaView} />
                <Route path="logs" component={registros.LogsC} />
              </Route>
            </Router>
            <general.SnackbarC />
          </div>
        </MuiThemeProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// src/mainComponent.js